import { FC, memo } from 'react';
import split from 'lodash/split';
import startCase from 'lodash/startCase';
import { Header as HeaderLayout } from 'antd/lib/layout/layout';

import HeaderActions from 'components/Header/HeaderActions';
import { headerCountByPathnameSelector } from 'store/selectors/listsSelectors';
import { useTypedSelector } from 'hooks/useTypedSelector';
import withLocation from 'hocs/withLocation';
import { ERoutePaths } from 'types/routes/enums';

const Header: FC<{ pathname: ERoutePaths }> = ({ pathname }) => {
  const count = useTypedSelector((state) => headerCountByPathnameSelector(state, { pathname }));

  return (
    <HeaderLayout className="flex items-center justify-between border-b border-black-20 dark:border-black-80">
      <h2 className="mb-0">
        {startCase(split(pathname, '/')[1])} {!!count && `(${count})`}
      </h2>
      <HeaderActions />
    </HeaderLayout>
  );
};

export default withLocation(memo(Header));
